/**
 * Marketing e Campanhas — placeholders navegáveis, com os mesmos cards do protótipo.
 * Cada bloco vira um documento vivo do time numa fase futura.
 */
import { TituloDaPagina } from '../shell/TituloDaPagina';

const BLOCOS = [
  { titulo: 'Posicionamento de marca', desc: 'Quem somos, no que acreditamos e como queremos ser percebidos.', cor: '#C9A25A' },
  { titulo: 'Objetivos e projeção financeira', desc: 'Metas de negócio, receita e sustentabilidade da temporada.', cor: '#4E9C6B' },
  { titulo: 'Setup estratégico', desc: 'Pilares de crescimento, canais e prioridades.', cor: '#5B8FB9' },
  { titulo: 'Setup tático', desc: 'Rotinas, ferramentas e execução do dia a dia.', cor: '#C0703C' },
  { titulo: 'Planejamento de campanhas', desc: 'Calendário e briefings de cada campanha.', cor: '#A87BD0' },
  { titulo: 'Guia de comunidade', desc: 'Tom, regras e rituais da comunidade.', cor: '#3FB0B0' },
];

const CAMPANHAS = [
  { titulo: 'Campanha Pré-Beta', desc: 'Aquecimento e lista de espera dos primeiros viajantes.', status: 'Rascunho' },
  { titulo: 'Abertura do Beta', desc: '200 viajantes. Convite pra mesa, não pra plateia.', status: 'Planejada' },
  { titulo: 'Contagem Season 1', desc: 'Vagas limitadas, regras seladas. A ilha acorda.', status: 'Planejada' },
];

export function Marketing() {
  return (
    <div>
      <TituloDaPagina>
        A base da marca do Mistik Island. Cada bloco vira um documento vivo do time.
      </TituloDaPagina>
      <div className="tiles">
        {BLOCOS.map((bloco) => (
          <div key={bloco.titulo} className="tile" style={{ '--c': bloco.cor, cursor: 'default' } as React.CSSProperties}>
            <div className="tn">{bloco.titulo}</div>
            <div className="td">{bloco.desc}</div>
            <div className="chip2">a preencher</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Campanhas() {
  return (
    <div>
      <TituloDaPagina>
        Planejador de campanhas, alinhado ao roadmap de lançamento (Beta → Season 1).
      </TituloDaPagina>
      <div className="tiles">
        {CAMPANHAS.map((campanha) => (
          <div key={campanha.titulo} className="tile" style={{ '--c': '#C9A25A', cursor: 'default' } as React.CSSProperties}>
            <div className="tn">{campanha.titulo}</div>
            <div className="td">{campanha.desc}</div>
            <div className="chip2">{campanha.status}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
